import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { Loader } from '@saucelabs/sl-component-loader';
import { records as jobsRecords } from '@saucelabs/sl-module-jobs';

import { selectors } from './../ducks/flatManual';
import ManualJobs from './../components/ManualJobs';
import ManualJobsEmptyState from '../components/EmptyState/ManualJobsEmptyState';
import Styles from './../containers/JobsContainer.styles';

const ManualJobsTab = ({
  manual,
  manualLoading,
  isOpenSauceUser,
  showSeeAllButton,
}) => (
  <Loader
    className={Styles.loader}
    fontSize={3}
    show={manualLoading}
  >
    {manual.size === 0 && !isOpenSauceUser ? (
      <ManualJobsEmptyState />
    ) : (
      <ManualJobs
        jobs={manual}
        showSeeAllButton={showSeeAllButton}
      />
    )}
  </Loader>
);

ManualJobsTab.propTypes = {
  isOpenSauceUser: PropTypes.bool.isRequired,
  manual: ImmutablePropTypes.listOf(
    ImmutablePropTypes.recordOf(jobsRecords.JobRecordClass).isRequired,
  ).isRequired,
  manualLoading: PropTypes.bool.isRequired,
  showSeeAllButton: PropTypes.bool.isRequired,
};

export default connect(
  selectors.manualJobsSelector,
)(ManualJobsTab);
export {
  ManualJobsTab,
};
